import generateSubjectsObject from '~/booking/utils/generateSubjectsObject'
import { TutorForSelfBookingFields } from '~/types/cart'

export function createBookingPreferenceFromCartItem(item: TutorForSelfBookingFields) {
  const { levelsOfEducation, location, product, subjects, ...rest } = item

  return {
    city: location,
    productId: product?.id ?? 0,
    subjects: generateSubjectsObject(subjects, levelsOfEducation),
    ...rest,
  }
}
